import './media.scss';

import React from 'react';

function Media() {
  return (
    <div className="row center-xs middle-xs around-md">
      <span className="media-logo media-logo--la-times" />
      <span className="media-logo media-logo--forbes" />
      <span className="media-logo media-logo--sf-weekly" />
      <span className="media-logo media-logo--tech-crunch" />
      <span className="media-logo media-logo--business-insider" />
    </div>
  );
}

export default Media;



// WEBPACK FOOTER //
// ./shared/components/home/landingPage/media.js